import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.canvas.text');
import { OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-nrich-canvas-text',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichCanvasTextComponent implements OnInit, OnChanges {
    @Input() documentId: string = '';
    @Input() pdfName: string = '';
    @Input() currentPage: number = 1;

    public textHtml: string = '';
    public pageMeta: string = '';
    public loading: boolean = true;
    public error: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.documentId && this.currentPage) {
            await this.loadText();
        }
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if ((changes['currentPage'] || changes['documentId']) && this.documentId) {
            await this.loadText();
        }
    }

    private async loadText() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('page_text', {
                document_id: this.documentId,
                page: this.currentPage,
            });
            if (code === 200) {
                this.textHtml = this.processTextToHtml(data.text || '', data.pdf_name || this.pdfName);
                const imgCount = data.image_count || 0;
                this.pageMeta = `${data.pdf_name || this.pdfName} — ${data.page || this.currentPage}페이지${imgCount > 0 ? ` · 이미지 ${imgCount}개` : ''}`;
            } else {
                this.error = '텍스트 로드 실패';
            }
        } catch (e: any) {
            this.error = '텍스트 로드 실패';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private processTextToHtml(text: string, pdfName: string): string {
        let html = this.escapeHtml(text);
        // <nrich-img id="page-num" /> → inline image
        html = html.replace(/&lt;nrich-img\s+id=&quot;(\d+)-(\d+)&quot;\s*\/&gt;/g, (_: any, page: string, num: string) => {
            const imgPath = this.encPath(`${pdfName}/images/${page}/${num}.png`);
            return `<span class="nrich-img-tag inline-block my-2 p-2 bg-zinc-50 rounded-lg border">
                <img src="/wiz/api/page.document.item/image?document_id=${encodeURIComponent(this.documentId)}&image_path=${imgPath}" alt="이미지 ${page}-${num}" loading="lazy" class="max-w-sm rounded" onerror="this.parentElement.style.display='none'">
                <span class="block text-xs text-zinc-500 mt-1">이미지 ${page}-${num}</span>
            </span>`;
        });
        // [[page:N]] → page link
        html = html.replace(/\[\[page:(\d+)\]\]/g, (_: any, p: string) => {
            return `<a class="text-indigo-600 hover:underline cursor-pointer text-xs" title="${p}페이지로 이동">📄 ${p}p</a>`;
        });
        html = html.replace(/\n/g, '<br>');
        return html;
    }

    private escapeHtml(text: string): string {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    private encPath(p: string): string {
        return p.split('/').map(s => encodeURIComponent(s)).join('/');
    }
}

export default PortalNrichCanvasTextComponent;